// DESIGN V2 — tiny formatting helpers shared by the Mixpedia entity pages,
// search results and the home rows. Pure functions, no React.

// 3925 → "3,925"; null/undefined/NaN → "".
export function fmtNum(n) {
    if (n == null || n === '' || Number.isNaN(Number(n))) return '';
    return Number(n).toLocaleString('en-US');
}

// "2026-09-02" / ISO / Date → "today" | "3 days ago" | "Sep 2" | "Sep 2, 2024".
// Falls back to the first 10 chars of the input when it is not a date.
export function relativeDate(input, now = new Date()) {
    if (!input) return '';
    const d = input instanceof Date ? input : new Date(String(input).length === 10 ? `${input}T00:00:00` : input);
    if (Number.isNaN(d.getTime())) return String(input).slice(0, 10);
    const dayMs = 86400000;
    const days = Math.floor((now - d) / dayMs);
    if (days < 0) return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    if (days === 0) return 'today';
    if (days === 1) return 'yesterday';
    if (days < 7) return `${days} days ago`;
    if (days < 28) { const w = Math.floor(days / 7); return `${w} ${w === 1 ? 'week' : 'weeks'} ago`; }
    if (d.getFullYear() === now.getFullYear()) return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

// Count on the right of a row: "142 plays" / "18 mixes". null when nothing is known.
export function rowCount(item, noun = 'plays') {
    if (!item) return null;
    const n = item.mixCount ?? item.mixesCount ?? item.playCount ?? item.tracksCount ?? item.count ?? null;
    if (!n) return null;
    const singular = noun === 'mixes' ? 'mix' : (noun.endsWith('s') ? noun.slice(0, -1) : noun);
    return `${fmtNum(n)} ${n === 1 ? singular : noun}`;
}
